export * from "./b2b-inquiry";
